const ww = window.innerWidth
const wh = window.innerHeight

const s7StaticH = ww / (1125 / 2436)

const sprites = {
  s6_static: {
    size: { mode: 'heightFit', height: 1 },
    position: { x: 0, y: 2 },
    anchor: { x: 0, y: 2 }
  },
  s6_me1: {
    size: { mode: 'heightFit', height: 0.369 },
    position: { x: 1, y: 0.548 },
    anchor: 'topLeft'
  },
  s6_me2: {
    size: { mode: 'heightFit', height: 0.363 },
    position: { x: 1, y: 0.556 },
    anchor: 'topLeft'
  },
  s6_talk1: {
    size: { mode: 'heightFit', height: 0.322 },
    position: { x: 0, y: 0.636 },
    anchor: 'bottomRight'
  },
  s6_text: {
    size: { mode: 'heightFit', height: 1000 / 2436 },
    position: { x: 0, y: 0.138 },
    anchor: 'topLeft'
  },
  s6_red: {
    key: 's6_red1',
    size: { mode: 'heightFit', height: 2690 / 2436 },
    position: { x: 425 / 1125, y: 1 - 998 / 2436 * s7StaticH / wh },
    anchor: { x: 703 / 1640, y: 1536 / 2690 }
  }
}

export default sprites



// WEBPACK FOOTER //
// ./src/assets/scenes/s6/sprites.js